export const isBrowser = () => typeof window !== `undefined`;

export const getToken = () => {
  return localStorage.getItem(`froneri-user`);
};

export const setToken = (token) => {
  if (token) {
    localStorage.setItem(`froneri-user`, token);
  }
};

export const removeToken = () => {
  localStorage.removeItem(`froneri-user`);
};

export const setRedirect = (path) => {
  if (path) {
    localStorage.setItem(`redirectAfterLogin`, path);
  }
};

export const getRedirect = () => {
  return localStorage.getItem(`redirectAfterLogin`);
};

export const removeRedirect = () => {
  localStorage.removeItem(`redirectAfterLogin`);
};
